// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__bgeyb","control":"Checkout_control__IZhEr","actions":"Checkout_actions__InuCf","submit":"Checkout_submit__8F6F-","invalid":"Checkout_invalid__td8fs"};